import { ReactNode } from 'react';
import { countriesTranslate } from '../../i18n';
import { countries } from '../../constants/countries';

interface CountryOption {
    label: string;
    value: string;
    flagIcon: ReactNode | null;
}

export const getCountriesOptions = (countriesCodes: string[]): CountryOption[] =>
    countriesCodes.map((code) => ({
        label: countriesTranslate(code),
        value: code,
        flagIcon: countries.get(code) ?? null,
    }));
